// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
// modern-bundle! import $ from 'jquery';

// modern-bundle! import $r from 'js/core_pre_webpack/routes';

// modern-bundle! const Aedu = {};
import User from 'sitewide-js/core_post_webpack/models/user';

Aedu.Dismissibles = {
  showIfAppropriate: function(nagName, showNagCallback) {
    var url = $r.api_v0_user_dismissible_path(this.params(nagName));

    return $.get(url).done(function(data) {
      if (data.show && showNagCallback) {
        showNagCallback();
      }
    });
  },

  recordShow: function(nagName) {
    var url = $r.record_show_api_v0_user_dismissibles_path(this.params(nagName));
    return $.post(url);
  },

  recordDismissal: function(nagName) {
    var url = $r.record_dismissal_api_v0_user_dismissibles_path(this.params(nagName));
    return $.post(url);
  },

  recordClickthrough: function(nagName, extraData) {
    extraData = (typeof extraData !== undefined) ? {extra_data: JSON.stringify(extraData)} : {};
    var data = Object.assign({}, this.params(nagName), extraData);
    var url = $r.record_clickthrough_api_v0_user_dismissibles_path(data);
    return $.post(url);
  },

  // As of May 2023, resetShow is unused throughout the codebase but left in because it can be
  // useful for debugging/testing.
  resetShow: function(nagName) {
    var url = $r.reset_show_count_api_v0_user_dismissibles_path(this.params(nagName));
    return $.post(url);
  },

  params: function(nagName) {
    var urlParams = {
      user_id: User.current ? User.current.id : "logged-out",
      id: nagName,
      href: window.location.href,
      subdomain_param: "api",
      auvid: window.$auvid,
    };

    if (window.Aedu && window.Aedu.hit_data) {
      urlParams.hit_id = window.Aedu.hit_data.id;
    }

    return urlParams;
  },
};

// modern-bundle! export default Aedu.Dismissibles;
